module.exports = __webpack_public_path__ + "static/deep_crow-1a97858bb5efc373863cef825fee8c11.png";